<template>
    <div class="header label" :style="{width:cellWidth}" @click="setSorting()"
         :class="[direction, align, {sortable,active, padded, fill, overflowed}]"
         v-if="shouldShow">
        <div class="header-content">
            <template v-if="active !== true && sortable === true">
                <div class="sortable-icons">
                    <awesome-icon icon="chevron-up"></awesome-icon>
                    <awesome-icon icon="chevron-down"></awesome-icon>
                </div>
            </template>
            <template v-if="active === true">
                <awesome-icon icon="chevron-down" v-if="direction === 'asc'" class="dir-indicator"></awesome-icon>
                <awesome-icon icon="chevron-up" v-else class="dir-indicator"></awesome-icon>
            </template>
            <template v-if="column.name">{{ column.name }}</template>
            <slot v-else></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: "sc-table-header",
  props: {
    columns: {},
    field: {},
    sorting: {},
    padded: {
      default: true,
    },
    table: {}
  },

  methods: {
    setSorting() {

      if (!this.sortable) {
        return
      }

      if (this.table) {

        this.table.changeSort(this.field);

        return;
      }

      if (this.sorting) {
        if (this.sorting.current.value === this.field) {
          if (this.sorting.current.dir === 'desc') {
            this.$emit('update:sorting', {})
          } else if (this.sorting.current.dir === 'asc') {
            this.$emit('update:sorting', {
              value: this.field,
              dir: 'desc',
              column: this.column,
            })
          } else {
            this.$emit('update:sorting', {
              value: this.field,
              dir: 'asc',
              column: this.column,
            })
          }
        } else {
          this.$emit('update:sorting', {
            value: this.field,
            dir: 'asc',
            column: this.column,
          })
        }
      }
    }
  },

  computed: {

    column() {
      if (this.table) {
        if (this.table.columns && this.table.columns[this.field]) {
          return this.table.columns[this.field]
        }
      } else {
        if (this.columns && this.columns[this.field]) {
          return this.columns[this.field]
        }
      }
    },

    active() {
      if (this.table) {
        if (this.table.sortColumn === this.field) {
          return true;
        }
      } else {
        if (this.sorting) {
          if (this.sorting.current.value === this.field) {
            return true
          }
        }
      }
    },

    sortable() {
      if (this.sorting) {
        return true;
      }
      if (this.column && (this.column.sort === true || this.column.sortable === true)) {
        if (this.table && this.table.hasData === true) {
          return true
        }
      }
    },

    direction() {
      if (this.active === true) {
        if (this.table) {
          return this.table.sortDir;
        } else {
          return this.sorting.current.dir
        }
      }
    },

    overflowed() {
      return !!this.config.overflowing;
    },

    shouldShow() {
      if (this.config && this.config.visible === false) {
        return false;
      } else {
        return true
      }
    },

    config() {
      return this.column;
    },

    fill() {
      if (this.config) {
        return !!this.config.fill;
      }
    },

    align() {
      if (this.config && this.config.align) {
        return 'align-' + this.config.align;
      }
    },

    cellWidth() {
      if (this.config && this.config.width) {
        return this.config.width + 'px'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
    box-sizing: border-box;
    transition: color .15s ease-in-out;
    position: relative;
    flex-shrink: 0;
    flex-grow: 0;

    &.overflowed {
        opacity: 0;
        pointer-events: none;
    }
}

.header.fill {
    flex-grow: 1;
}

.theme--default {
    .header {
        color: #00000066;

        &.active {
            color: #333;
        }

        &.sortable:hover {
            color: #333;
            cursor: pointer;
        }
    }
}

.theme--dark {
    .header {
        color: #ccc;

        &.active {
            color: #fff;
        }

        &.sortable:hover {
            color: #fff;
            cursor: pointer;
        }
    }
}

.dir-indicator {
    position: absolute;
    left: 2px;
    top: 50%;
    transform: translateY(-60%)
}

.header .header-content {
    word-break: break-all;
    padding: 0px 16px;
    position: relative;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently */
}

.header.align-right {
    justify-content: flex-end;
}

.header.padded .header-content {
    padding: 12px 16px;
}

.sortable-icons {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 4px;
    top: 52%;
    transform: translateY(-60%);
    font-size: 0.5em;
}
</style>